export const chatTheme: Record<string, string> = {
  '--sendbird-light-primary-500': '#353637',
  '--sendbird-light-primary-400': '#464748',
  '--sendbird-light-primary-300': '#58595B',
  '--sendbird-light-primary-200': '#797A7B',
  '--sendbird-light-primary-100': '#9A9A9B',

  '--sendbird-dark-primary-500': '#353637',
  '--sendbird-dark-primary-400': '#464748',
  '--sendbird-dark-primary-300': '#58595B',
  '--sendbird-dark-primary-200': '#797A7B',
  '--sendbird-dark-primary-100': '#9A9A9B',
};
